module.exports = __webpack_public_path__ + "static/media/info.61901c13.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/info.png
 ** module id = 322
 ** module chunks = 0
 **/